<template>
    <div class="h-full max-h-screen">
        <transition name="fade">
            <div v-show="modalActive" @click.self="closeModal" @keydown.esc="closeModal"
            class="bg-black bg-opacity-20 backdrop-blur z-50 fixed top-0 left-0 h-full w-full flex  justify-center animate-in fade-in duration-300 items-center py-8 overflow-y-scroll overflow-x-hidden scrollbar-hide js_close_clickable">
                <transition name="fade">
                    <div v-show="modalActive" class="w-full h-full flex justify-center items-center" @click.self="closeModal">
                        <slot name="modal_content"></slot>
                    </div>
                </transition>
            </div>
        </transition>

        <button type="button" @click="open" class="h-full w-full">
            <slot name="modal_button">Click here</slot>
        </button>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            modalActive: this.$attrs.modalActive ?? false,
        }
    },

    methods: {
        open() {
            $("body").addClass("scroll_lock")
            this.modalActive = true;
        },
        closeModal() {
            this.modalActive = false;
            setTimeout(function () {
            $("body").removeClass("scroll_lock")
            }, 200);
        }
    }
};
</script>